// extracted by mini-css-extract-plugin
module.exports = {"metrics-container":"MetricsWidget_metrics-container__2RYZU","metric":"MetricsWidget_metric__3D9y-","with-tooltip":"MetricsWidget_with-tooltip__34aEF"};